import { render, staticRenderFns } from "./AdmissionAprove.vue?vue&type=template&id=4d5a1e38&"
import script from "./AdmissionAprove.vue?vue&type=script&lang=js&"
export * from "./AdmissionAprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports